import { useMutation } from "@tanstack/react-query";
import { inquiryApi, type InquiryApi } from "@bw/shared/api";
import { INLINE_GUARDIAN_PROMPT } from "../../../common/guardian/denials";

/** Lesson interest uses the canonical limited, replay-safe inquiry command. */
export function useRequestLesson() {
  return useMutation({
    meta: INLINE_GUARDIAN_PROMPT,
    mutationFn: (body: Parameters<InquiryApi["create"]>[0]) => inquiryApi.create(body),
    retry: false,
  });
}
